// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"dfb00ddd","71":"a79d9c68","97":"3fda5e91","316":"4149d1a7","400":"6f2c74d5","575":"703232dc","742":"063d3e76","799":"3b77b5a6"}[chunkId] + ".chunk.js";
};